import api from '@/helpers/api'
import axios from 'axios'

const API_HOST = process.env.VUE_APP_API_HOST

export default {
    // Setup 2FA: Get QR Code and Secret
    setup() {
        return api.request('get', '/api/user/2fa/setup')
    },

    // Confirm 2FA setup with OTP code
    confirm(code) {
        return api.request('post', '/api/user/2fa/confirm', {}, { code })
    },

    // Disable 2FA (requires password)
    disable(password) {
        // Axios delete with data body requires 'data' property in config
        return api.request('delete', '/api/user/2fa', {}, { password })
    },

    // Get recovery codes info
    getRecoveryCodes() {
        return api.request('get', '/api/user/2fa/recovery-codes')
    },

    // Regenerate recovery codes (requires password)
    regenerateRecoveryCodes(password) {
        return api.request('post', '/api/user/2fa/recovery-codes/regenerate', {}, { password })
    },

    // Verify 2FA during login using OTP
    verify2FA(code, tempToken) {
        const clientDomain = window.location.hostname.replace('https://', '');
        return axios.post(`${API_HOST}/api/auth/verify-2fa`, { code }, {
            headers: {
                'Authorization': `Bearer ${tempToken}`,
                'X-Tenant-Domain': clientDomain
            }
        })
    },

    // Recover 2FA during login using recovery code
    recover2FA(recoveryCode, tempToken) {
        const clientDomain = window.location.hostname.replace('https://', '');
        return axios.post(`${API_HOST}/api/auth/2fa/recover`, { recovery_code: recoveryCode }, {
            headers: {
                'Authorization': `Bearer ${tempToken}`,
                'X-Tenant-Domain': clientDomain
            }
        })
    }
}
